import type { Dispute } from '@/types';

export const mockDisputes: Dispute[] = [
  {
    id: 'dispute-001',
    payout_line_id: 'payout-003',
    lead_id: 'lead-003',
    raised_by_user_id: 'pp-001',
    raised_at: '2025-04-30T14:00:00Z',
    reason: 'duplicate',
    detail: 'This lead appears to be a duplicate of a case we already received last month. Same phone number and incident description.',
    evidence: { previous_lead_id: 'lead-prev-001', notes: 'Verified duplicate in our CRM' },
    status: 'pending',
    resolved_by_user_id: null,
    resolved_at: null,
    resolution_note: null,
    refund_amount_eur: null,
    created_at: '2025-04-30T14:00:00Z',
    updated_at: '2025-04-30T14:00:00Z'
  }
];